import React from 'react'
import './superxTestimonialsPage.css'
import C2wGridImageView from '../../../common/C2wSuperxHome/pages/superxProjectDetail/gridImageView'

function C2wSuperxTestimonialsPage() {
  return (
    <div className='C2wSuperxTestimonialsPage_ctn'>
        <div className='C2wSuperxTestimonialsPage_ctn_scroller'>
          <C2wGridImageView />
        </div>
    </div>
  )
}

export default C2wSuperxTestimonialsPage

